export default __webpack_public_path__ + "static/media/share_your_story.ca25b818.jpeg";